module.exports = __webpack_public_path__ + "img/adminName.3c710b81.png";